<template>
	<div class="lockUserDetail">
		<div class="title-con">
			<div class="left-con">
				<span class="title">用户列表</span>
				<a class="lockUserHelp" href="https://shimo.im/doc/jzvfab0MuZ01GTLV?r=MKZ48/" target="_blank" v-if="promotorType=='1'">查看用户锁定操作方法</a>
			</div>
			<div class="dateFilter">
				<span>时间筛选：</span>
				<el-date-picker v-model="dateRange" type="daterange" size="small" placeholder="选择日期"></el-date-picker>
				<el-button type="primary" size="small" @click="dateFilter">搜索</el-button>
				<a class="el-button el-button--primary el-button--small" 
				:href="`/lock/detail/export?from=${exportParams().from}&to=${exportParams().to}`" 
				target="_blank" ><i class="el-icon-document"></i><span style="font-size: 12px" class="exportText">导出表格</span></a>
			</div>
		</div>
		<p class="tableTips" v-if="lockData">销售额和佣金不是实时数据，上一次更新时间为{{lockData.operateDate}}，锁定时间和信息为实时数据</p>
		<el-table :data="lockData.list" stripe style="width: 100%" v-if="lockData">
			<el-table-column 
			:label="iKey.label" 
			:label-class-name="iKey.key" 
			:width="iKey.width" 
			v-for="iKey in lockDetailKey" :key="iKey.key" 
			v-if="(iKey.key!='mobile'&&iKey.key!='promotorName')||promotorType=='1'" 
			:show-overflow-tooltip="iKey.key!='promotorName' ?true: false"
			>
				<template slot-scope="scope">
					<span v-if="iKey.key!='promotorName'">{{ scope.row[iKey.key]}}</span>
					<!-- 锁定渠道添加详细信息下拉展示 -->
					<el-popover 
					trigger="hover" 
					placement="right"
					:ref="scope.row.uid"
					v-if="iKey.key=='promotorName'"
					>
						<p v-for="item in scope.row[iKey.template].split('$#$')">{{item}}</p>
						<span slot="reference" class="name-wrapper" v-if="promotorType==1">
							<!-- {{合伙人渠道展示}} -->
							{{scope.row[iKey.key].split('-')[0] == '合伙人' ? `城市服务商-${scope.row[iKey.key].split('-')[1]}` : scope.row[iKey.key]}}
							<i class="el-icon-caret-right"></i>
						</span>
						<span slot="reference" class="name-wrapper" v-if="promotorType==2">
							<!-- {{分销商渠道展示}} -->
							{{scope.row[iKey.key].split('-')[1]}}
							<i class="el-icon-caret-right"></i>
						</span>
					</el-popover>
		      	</template>
			</el-table-column>
		</el-table>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:currentPage="lockData.curPage"
			:page-sizes="[10, 20, 30, 40]"
			:page-size="lockData.pageSize"
			layout="total, sizes, prev, pager, next"
			:total="lockData.total"
			v-if="lockData">
		</el-pagination>
		<p class="oTip">用户在您的子站或者您分销商的子站购买商品的销售额</p>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import { lockDetail, lockPromotorDetail } from '../../api'
	import { parseTime } from '../../utils'

	export default {
		data() {
			return {
				lockData: null,
				dateRange: [null,null],
				lockDetailKey: [
					{
						key: 'nickName',
						label: '昵称',
						width: 120,
					},
					{
						key: 'uid',
						label: '用户id',
						width: 110,
					},
					{
						key: 'mobile',
						label: '手机号',
						width: 124,
					},
					{
						key: 'myAmount',
						// label: '我的渠道销售额',
						label: '站外销售额',
						width: 160,
					},
					{
						key: 'myBrokerage',
						// label: '我的渠道佣金',
						label: '站外佣金',
						width: 125,
					},
					{
					 	key: 'lockAmount',
					 	// label: '锁定销售额',
					 	label: 'APP内销售额',
					 	width: 120,
					},
					{
					 	key: 'lockBrokerage',
					 	// label: '锁定用户佣金',
					 	label: 'APP内订单佣金',
					 	width: 140,
					},
					{
						key: 'origin',
						label: '锁定方式',
						width: 150,
					},
					{
						key: 'promotorName',
						label: '锁定渠道',
						width: 200,
						template: 'extraChannelMsg'
					},
					{
						key: 'lockDate',
						label: '锁定时间',
						width: 170,
					}
				]
			}
		},
		computed: {
	      ...mapGetters([
	        'promotorType'
	      ])
	    },
		methods: {
			handleSizeChange(pageSize) {
				let _this = this;
				if(_this.dateRange[0] && _this.dateRange[1]){
					let curPage = _this.lockData.curPage;
					let {from, to} = _this.dateParse();
					_this.fetchData({from, to, curPage, pageSize})
				}else{
					_this.fetchData({pageSize});
				}
			},
			handleCurrentChange(curPage) {
				let _this = this;

				if(_this.dateRange[0] && _this.dateRange[1]){
					let pageSize = _this.lockData.pageSize;
					let {from, to} = _this.dateParse();
					_this.fetchData({from, to, curPage, pageSize})
				}else{
					_this.fetchData({curPage});
				}
			},
			dateParse() {
				let _this = this;
				let from = parseTime(_this.dateRange[0]);
				let to = parseTime(_this.dateRange[1]).replace('00:00:00','23:59:59');
				return {from, to}
			},
			dateFilter() {
				let _this = this;
				if(_this.dateRange[0] && _this.dateRange[1]){
					let {from, to} = _this.dateParse();
					_this.fetchData({from, to})
				}else{
					_this.fetchData({});
				}
			},
			exportParams() {
				let _this = this;
				let from = '', to = '';
				if(_this.dateRange[0] && _this.dateRange[1]){
					return _this.dateParse();
				}
				return {from, to};
			},
			addTips() {
				let oTarget = document.querySelector('.cell.myAmount');
				if(oTarget){
					// tipIcon
					let oHelp = document.createElement('div');
					oHelp.innerHTML = '?';
					oHelp.style.cssText = 'position:absolute;top:50%;right:24px;transform:translateY(-50%);display:flex;justify-content:center;align-items:center;font-size:12px;color:#fff;width:15px;height:15px;border-radius:50%;background-color:#1f2d3d;cursor:pointer';
					oTarget.appendChild(oHelp);

					let oTip = document.querySelector('.oTip');
					let hoverFn = function (e) {
						let { clientX, clientY } = e;
						oTip.style.display = 'block';
						oTip.style.top = (clientY - 130) + 'px';
						oTip.style.left = (clientX - 135) + 'px';
					}
					let outFn = function () {
						oTip.style.display = 'none';
						oTip.style.top = 0;
						oTip.style.left = 0;
					}
					oHelp.onmouseover = hoverFn;
					oHelp.onmousemove = hoverFn;
					oHelp.onmouseout = outFn;
				}
			},
			fetchData(obj) {
				let _this = this;
				let params = {};
				if(!obj.from && !obj.to){
					params['curPage'] = (_this.lockData && _this.lockData.curPage) || 1;
					params['pageSize'] = (_this.lockData && _this.lockData.pageSize) || 20;
				}
				for(var key in obj){
					params[key] = obj[key];
				}
				// console.log(params)
				if (this.promotorType=='1') {
					lockDetail(params).then(res => {
						if(res.ret === 0){
							let { curPage, pageSize, total } = res.data;
							let maxPage = Math.ceil(total/pageSize);

							if(curPage > maxPage){
								obj['curPage'] = maxPage;
								_this.fetchData(obj)
							}else{
								_this.lockData = res.data;
							}

							// 添加tip提示图标
							// _this.$nextTick(() => _this.addTips());
						}
					})
				} else {
					lockPromotorDetail(params).then(res => {
						if(res.ret === 0){
							let { curPage, pageSize, total } = res.data;
							let maxPage = Math.ceil(total/pageSize);

							if(curPage > maxPage){
								obj['curPage'] = maxPage;
								_this.fetchData(obj)
							}else{
								_this.lockData = res.data;
							}

							// 添加tip提示图标
							// _this.$nextTick(() => _this.addTips());
						}
					})
				}
			},
		},
		created() {
			let _this = this;
			_this.fetchData({});
		}
	}
</script>

<style lang="scss" scoped>
.lockUserDetail{
	width: 1110px;
}
.title-con{
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 20px;
	margin-bottom: 10px;
	background-color: #fff;
	.title{
		margin-right: 10px;
		font-size: 18px;
	}
	.lockUserHelp{
		font-size: 14px;
	}
	.dateFilter{
		display: flex;
		align-items: center;
		span{
			margin: 0 10px;
			font-size: 14px;
		}
	}
	.exportText{
	    margin-left: 5px;
	}
}
.oTip{
	display: none;
	position: absolute;
	top: 0;
	left: 0;
	padding: 8px;
	font-size: 14px;
	color: #333;
	width: 114px;
	color: #fff;
	background-color: #1f2d3d;
	border-radius: 5px;
	z-index: 10;
}
.tableTips{
	padding: 10px 5px;
	font-size: 14px;
	color: #999;
}
.name-wrapper {
	span {
		max-width: 120px;
		// display: inline-block;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
	i{
		font-size: 12px;
		color: #ccc;
		padding-left: 5px;
	}
}
</style>



// WEBPACK FOOTER //
// lockUserDetail.vue?6d853f15